import { DotAnimation } from "components/common/Animation/DotAnimation/DotAnimation";
import type { ReactNode } from "react";
import type { Progress as ProgressType } from "store/types/Progress";

interface LinearProgressProps {
    text: ReactNode;
    percentage: ProgressType;
    isBoldOnHover?: boolean;
    testId?: string;
    handleClick?: () => void;
}

export const LinearProgress = ({ text, percentage, isBoldOnHover, handleClick, testId }: LinearProgressProps) => {
    return (
        <div
            className={`relative w-full rounded-xl text-black font-normal pointer-events-auto ${
                isBoldOnHover && "hover:font-semibold"
            }`}
            onClick={(e) => {
                e.stopPropagation();
                handleClick && handleClick();
            }}
            data-testid={`${testId}`}
        >
            {percentage === "continuous" ? (
                <div>
                    {text}
                    <DotAnimation />
                </div>
            ) : (
                <div className="text-white bg-irBlue-200 dark:bg-darkPrimary-100 py-1">{text}</div>
            )}
            {percentage !== "continuous" && (
                <div
                    className="absolute inset-0 text-black dark:text-white py-1 bg-white dark:bg-darkSurface-200"
                    style={{ clipPath: `inset(0 0 0 ${percentage}%)` }}
                    data-testid={`${testId}-text`}
                >
                    {text}
                </div>
            )}
        </div>
    );
};
